
    // import {useStore} from "@/store";
    // , computed, ComputedRef, watch, reactive
    import  reportMsgUt from "@/util/reportMsg";
    import {defineComponent, watch, reactive, toRefs} from "vue";
    import {useRouter,useRoute} from "vue-router";

interface State {
    reportMsg: object;
}
export default defineComponent({
    name: 'checkTitle',
    props: {
        itemCode: {
            type: String,
            default: ''
        },
        titleCont: {
            type: String,
            default: ''
        },
        count: {
            type: Number,
            default: 0
        }
    },
    setup() {
        let state: State = reactive({
            reportMsg: {},

        })
        state.reportMsg = reportMsgUt;

        // 获取路由器实例
        const router = useRouter()
        return {
            state,
            router
        }
    },
    methods: {
        handleClick(checkTitle){
            this.router.push({
                path: '/checkStandard',
                query: {
                    checkTitle
                }
            })
        }
    }
})
